import {Component, OnDestroy, OnInit} from '@angular/core';
import {Curriculum} from '@models/curriculum';
import {StudentCreateComponent} from '@pages/layout/student/student-create/student-create.component';
import {CreateProgramCurriculumComponent} from '@pages/layout/program/program-page/program-curriculum/create-program-curriculum/create-program-curriculum.component';
import {MatDialog} from '@node_modules/@angular/material';
import {ActionTypes} from '@store/program/actions';
import {CurriculumService} from '@services/curriculum/curriculum.service';
import {Lesson} from '@models/lesson';
import {Store} from '@node_modules/@ngrx/store';
import * as ProgramReducer from '@store/program/reducers';
import {animate, style, transition, trigger} from '@node_modules/@angular/animations';
import {ConfirmModalComponent} from '@components/confirm-modal/confirm-modal.component';
import {ActivatedRoute, Router} from '@node_modules/@angular/router';
import {User} from '@models/user';
import * as AuthReducer from '@store/auth/reducers';
import {StudentCurriculumPageComponent} from '@pages/layout/curriculum/student-curriculum-page/student-curriculum-page.component';
import {FormControl, FormGroup, Validators} from '@angular/forms';

@Component({
  selector: 'app-curriculum-page',
  templateUrl: './curriculum-page.component.html',
  styleUrls: ['./curriculum-page.component.scss'],
  animations: [
    trigger(
      'enterAnimation', [
        transition(':enter', [
          style({opacity: 0}),
          animate('230ms', style({opacity: 1}))
        ]),
        transition(':leave', [
          style({opacity: 1}),
          animate('180ms', style({opacity: 0}))
        ])
      ],
    ),
    trigger(
      'slideAnimation', [
        transition(':enter', [
          style({transform: 'translateX(100%)'}),
          animate('150ms', style({transform: 'translateX(0)'}))
        ]),
        transition(':leave', [
          style({transform: 'translateX(0)'}),
          animate('100ms', style({transform: 'translateX(100%)'}))
        ])
      ],
    ),
    trigger(
      'heightAnimation', [
        transition(':enter', [
          style({height: '62px'}),
          animate('200ms', style({height: '*'}))
        ]),
        transition(':leave', [
          style({height: '*'}),
          animate('200ms', style({height: '62px'}))
        ])
      ],
    ),
  ]
})
export class CurriculumPageComponent implements OnInit, OnDestroy {

  static redirectParams;
  static usersCurriculums: Curriculum[];
  static modalRef;
  curriculums: Curriculum[];
  searchCurriculums: Curriculum[];
  currentCurriculum: Curriculum;
  curriculumId;
  lessonId;
  redirectPage;
  currentLesson: Lesson;
  searchValue;
  createCurriculumDialog;
  subscribes = [];
  isEditing = false;
  isEditingDetails = false;
  detailsMode: 'create' | 'edit' = 'create';
  detailsForm: FormGroup;
  editingDetailsCurriculum: Curriculum;
  selectedImageFile: File;
  imagePreview: string;
  isSavingDetails = false;
  detailsError: string;
  user: User;
  isDarkTheme = false;
  isCurriculumSidebarCollapsed = false;

  confirmDialog;
  constructor(
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private router: Router,
    private curriculumService: CurriculumService,
    private authStore: Store<AuthReducer.AuthState>,
    private programStore: Store<ProgramReducer.ProgramState>
  ) {
    route.queryParams.subscribe(params => {
      this.redirectPage = params['page'];
      this.curriculumId = +params['curriculum_id'];
      this.lessonId = +params['lesson_id'];
    });
  }

  ngOnInit() {
    this.isDarkTheme = localStorage.getItem('mkc-dashboard-theme') === 'dark';
    this.applyTheme();

    this.subscribes.push(this.programStore.subscribe(
      (val) => {
        if (val &&  val.program) {
          const programs = val.program;
          if (programs.lastAction === ActionTypes.SET_CURRICULUM) {
            if (this.isEditing && this.redirectPage) {
              this.router.navigate(['/'+this.redirectPage], {queryParams: CurriculumPageComponent.redirectParams});
            }
            this.setData();
            if (this.createCurriculumDialog) {
              this.createCurriculumDialog.close();
            }
          } else if (programs.lastAction === ActionTypes.UPDATE_CURRICULUM) {
            // Builder dispatches UPDATE_CURRICULUM after lesson/block create or drag-copy.
            // Sync the updated curriculum into the page state without clearing the view
            // or forcing a full reload. SET_CURRICULUM behaviour is unchanged.
            this.syncUpdatedCurriculum(programs.currentCurriculum);
          }
        }
      }
    ));
    this.subscribes.push( this.authStore.subscribe(
      (val) => {
        const auth = val.auth;
        if (auth && auth.user) {
          this.user = auth.user;
        }
      }
    ));
    if (!this.user.notAdmin) {
      this.setData();
    } else if (CurriculumPageComponent.usersCurriculums) {
      this.curriculums = CurriculumPageComponent.usersCurriculums;
    }
  }
  ngOnDestroy() {
    this.subscribes.map( subsrc => subsrc.unsubscribe());
  }
  get visibleCurriculums(): Curriculum[] {
    return this.searchCurriculums || this.curriculums || [];
  }
  onSearchCurriculums(input, searchAction = true) {
    if (input && searchAction) {
      this.searchCurriculums = this.curriculums.filter( curriculum => !curriculum.name.toLowerCase().search(this.searchValue.toLowerCase()));
    } else {
      this.searchValue = '';
      this.searchCurriculums = null;
    }
  }
  openCreateModalAction() {
    CreateProgramCurriculumComponent.source = 'curriculum';
    CreateProgramCurriculumComponent.parent_id = null;
    CreateProgramCurriculumComponent.isEdit = false;
    CreateProgramCurriculumComponent.editingItem = null;
    this.createCurriculumDialog = this.dialog.open(CreateProgramCurriculumComponent);
    CreateProgramCurriculumComponent.modalRef = this.createCurriculumDialog;
    this.createCurriculumDialog.afterClosed().subscribe(result => {
      this.createCurriculumDialog.close();
    });
  }
  openBuilderPage(event, curriculum: Curriculum) {
    event.stopPropagation();
    if (this.user && this.user.notAdmin) {
      return;
    }
    this.cancelDetailsForm();
    this.currentCurriculum = curriculum;
    this.isEditing = true;
  }
  // Called by the top page back arrow when in builder mode (req 588).
  // Exit builder → return to curriculum VIEW mode.
  // Do NOT call setData() here — that would clear currentCurriculum and
  // send the user to the grid instead of the detail view.
  exitBuilderMode() {
    this.isEditing = false;
  }
  openCreateDetails(event?) {
    if (event) {
      event.stopPropagation();
    }
    if (this.user && this.user.notAdmin) {
      return;
    }
    this.openDetailsForm(null, 'create');
  }
  openEditDetails(event, curriculum: Curriculum) {
    event.stopPropagation();
    if (this.user && this.user.notAdmin) {
      return;
    }
    this.openDetailsForm(curriculum, 'edit');
  }
  openDetailsForm(curriculum: Curriculum = null, mode: 'create' | 'edit' = 'edit') {
    if (this.user && this.user.notAdmin) {
      return;
    }
    this.isEditing = false;
    this.isEditingDetails = true;
    this.detailsMode = mode;
    this.editingDetailsCurriculum = curriculum;
    this.selectedImageFile = null;
    this.imagePreview = curriculum ? this.getCurriculumImage(curriculum) : this.getCurriculumImage(null);
    this.isSavingDetails = false;
    this.detailsError = null;
    this.detailsForm = new FormGroup({
      name: new FormControl(curriculum ? curriculum.name : '', [
        Validators.required,
        Validators.minLength(3)
      ]),
      description: new FormControl(curriculum ? curriculum.description || '' : '', [
        Validators.required
      ])
    });
  }
  cancelDetailsForm() {
    this.isEditingDetails = false;
    this.detailsMode = 'create';
    this.detailsForm = null;
    this.editingDetailsCurriculum = null;
    this.selectedImageFile = null;
    this.imagePreview = null;
    this.isSavingDetails = false;
    this.detailsError = null;
  }
  onImageFileChanged(event) {
    const file = event && event.target && event.target.files && event.target.files[0];
    if (!file) {
      return;
    }
    if (file.type && !file.type.match(/^image\//)) {
      this.detailsError = 'Choose an image file.';
      return;
    }
    const maxSizeBytes = 250 * 1024; // 250 KB
    if (file.size > maxSizeBytes) {
      this.selectedImageFile = null;
      this.detailsError = 'Image is too large. Please upload an image under 250 KB, or resize/compress it first.';
      return;
    }
    this.selectedImageFile = file;
    this.detailsError = null;

    const reader = new FileReader();
    reader.onload = (readerEvent: any) => {
      this.imagePreview = readerEvent.target.result;
    };
    reader.readAsDataURL(file);
  }
  saveDetails() {
    if (this.user && this.user.notAdmin) {
      return;
    }
    if (!this.detailsForm || this.isSavingDetails) {
      return;
    }
    if (this.detailsForm.invalid) {
      this.touchDetailsForm();
      return;
    }

    this.isSavingDetails = true;
    this.detailsError = null;

    const body: any = {
      name: this.detailsForm.get('name').value,
      description: this.detailsForm.get('description').value
    };

    if (this.selectedImageFile) {
      this.curriculumService.uploadImage(this.selectedImageFile).subscribe(
        (imageResponse) => {
          const imageValue = this.getUploadedImageValue(imageResponse);
          if (!imageValue) {
            this.isSavingDetails = false;
            this.detailsError = 'Image upload finished without an image URL.';
            return;
          }
          body.image = imageValue;
          this.saveDetailsBody(body);
        },
        () => {
          this.isSavingDetails = false;
          this.detailsError = 'Image upload failed. Please check the file type and size. Use JPG, PNG, or WebP under 250 KB.';
        }
      );
      return;
    }

    this.saveDetailsBody(body);
  }
  // onDeleteCurriculum(event, curriculum: Curriculum) {
  //   event.stopPropagation();
  //   console.log(curriculum);
  // }
  setData() {
    this.curriculumService.getAll(null, 'curriculum').subscribe(
      (rsp: {data: Curriculum[]}) => {
        this.curriculums = rsp.data;
        if (this.curriculumId) {
          this.curriculums.map( item => {
            if (item.id === this.curriculumId) {
              this.currentCurriculum = item;
              if (this.lessonId) {
                this.currentCurriculum.lessons.map( lesson => {
                  if (lesson.id === this.lessonId) {
                    this.currentLesson = lesson;
                  }
                })
              }
              this.isEditing = true;
            }
          });
        } else {
          this.currentCurriculum = null;
          this.searchCurriculums = null;
          this.searchValue = '';
          this.isEditing = false;
        }
      }
    );
  }
  openCurriculumView(curriculum: Curriculum) {
    this.cancelDetailsForm();
    this.currentCurriculum = curriculum;
    this.currentLesson = null;
    this.isCurriculumSidebarCollapsed = false;
  }
  clearCurrentCurriculum() {
    this.cancelDetailsForm();
    this.currentCurriculum = null;
    this.currentLesson = null;
  }
  setCurrentCurriculum(curiculum: Curriculum) {
    this.cancelDetailsForm();
    this.currentCurriculum = curiculum;
    this.currentLesson = null;
  }
  getCurriculumImage(curriculum: Curriculum) {
    return curriculum && curriculum.image ? curriculum.image : 'assets/curriculum_default.png';
  }
  getLessonCount(curriculum: Curriculum) {
    return curriculum && curriculum.lessons ? curriculum.lessons.length : 0;
  }
  getDescriptionPreview(curriculum: Curriculum) {
    const description = this.getPlainDescription(curriculum);
    return description.length > 140 ? description.slice(0, 137) + '...' : description;
  }
  getPlainDescription(curriculum: Curriculum) {
    if (!curriculum || !curriculum.description) {
      return 'No description added yet.';
    }
    return curriculum.description
      .replace(/<[^>]*>/g, ' ')
      .replace(/&nbsp;/g, ' ')
      .replace(/&amp;/g, '&')
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/\s+/g, ' ')
      .trim() || 'No description added yet.';
  }
  private saveDetailsBody(body) {
    if (this.detailsMode === 'create') {
      this.curriculumService.create(body, 'curriculum').subscribe(
        () => {
          this.cancelDetailsForm();
          this.clearCurrentCurriculum();
          this.setData();
        },
        () => {
          this.isSavingDetails = false;
          this.detailsError = 'Curriculum could not be created. Please try again.';
        }
      );
      return;
    }

    if (!this.editingDetailsCurriculum || !this.editingDetailsCurriculum.id) {
      this.isSavingDetails = false;
      this.detailsError = 'No curriculum selected for editing.';
      return;
    }

    this.curriculumService.update(body, this.editingDetailsCurriculum.id).subscribe(
      (resp) => {
        const updated = this.getCurriculumFromResponse(resp);
        if (updated && updated.id) {
          this.replaceCurriculum(updated);
        } else {
          this.setData();
        }
        this.cancelDetailsForm();
      },
      () => {
        this.isSavingDetails = false;
        this.detailsError = 'Curriculum details could not be saved. Please try again.';
      }
    );
  }
  private touchDetailsForm() {
    Object.keys(this.detailsForm.controls).map(key => {
      this.detailsForm.get(key).markAsTouched();
    });
  }
  private getUploadedImageValue(resp) {
    const payload = resp && resp.data ? resp.data : resp;
    return payload ? payload.imageUrl || payload.generatedName : null;
  }
  private getCurriculumFromResponse(resp): Curriculum {
    return resp && resp.data ? resp.data : resp;
  }
  private replaceCurriculum(updated: Curriculum) {
    if (this.curriculums) {
      this.curriculums = this.curriculums.map(curriculum => {
        return curriculum.id === updated.id ? updated : curriculum;
      });
    }
    if (this.searchCurriculums) {
      this.searchCurriculums = this.searchCurriculums.map(curriculum => {
        return curriculum.id === updated.id ? updated : curriculum;
      });
    }
    if (this.currentCurriculum && this.currentCurriculum.id === updated.id) {
      this.currentCurriculum = updated;
    }
    if (this.editingDetailsCurriculum && this.editingDetailsCurriculum.id === updated.id) {
      this.editingDetailsCurriculum = updated;
    }
  }

  // Syncs an UPDATE_CURRICULUM store event into page state without wiping the view.
  // Calls replaceCurriculum for the curriculum/search arrays and currentCurriculum,
  // then re-anchors currentLesson to the matching lesson in the refreshed data.
  private syncUpdatedCurriculum(updated: Curriculum): void {
    if (!updated || !updated.id) { return; }
    this.replaceCurriculum(updated);
    if (this.currentLesson) {
      const prevLessonId = this.currentLesson.id;
      const lessons = (updated.lessons || []) as Lesson[];
      const stillExists = lessons.find(l => l.id === prevLessonId);
      this.currentLesson = stillExists || null;
    }
  }
  actionDelete(params) {
    if (this.user && this.user.notAdmin) {
      return;
    }
    const body = {
      source: params.source,
      id: params.item.id,
    };
    this.curriculumService.deleteItem(body).subscribe(
      (resp: {data: Curriculum}) => this.setData()
    );
  }
  onDelete(event, source: string, item) {
    event.stopPropagation();
    if (this.user && this.user.notAdmin) {
      return;
    }
    ConfirmModalComponent.insertedObject = this;
    ConfirmModalComponent.methodDelete = 'actionDelete';
    ConfirmModalComponent.methodDeleteParam = {source: source, item: item};
    ConfirmModalComponent.methodDeleteAllParam = true;
    this.confirmDialog = this.dialog.open(ConfirmModalComponent);
    ConfirmModalComponent.modalRef = this.confirmDialog;
    this.confirmDialog.afterClosed().subscribe(result => {
      this.confirmDialog.close();
    });
  }
  isModal() {
    return !!CurriculumPageComponent.modalRef;
  }
  close() {
    CurriculumPageComponent.modalRef.close();
  }

  setTheme(theme: 'light' | 'dark') {
    this.isDarkTheme = theme === 'dark';
    localStorage.setItem('mkc-dashboard-theme', theme);
    this.applyTheme();
  }

  toggleCurriculumSidebar(): void {
    this.isCurriculumSidebarCollapsed = !this.isCurriculumSidebarCollapsed;
  }

  collapseCurriculumSidebar(): void {
    this.isCurriculumSidebarCollapsed = true;
  }

  expandCurriculumSidebar(): void {
    this.isCurriculumSidebarCollapsed = false;
  }

  showCurriculumOverview(): void {
    this.currentLesson = null;
  }

  getCurrentLessonIndex(): number {
    if (!this.currentCurriculum || !this.currentCurriculum.lessons || !this.currentLesson) {
      return -1;
    }
    return this.currentCurriculum.lessons.findIndex(l => l.id === this.currentLesson.id);
  }

  getCurrentLessonNumber(): number {
    const idx = this.getCurrentLessonIndex();
    return idx >= 0 ? idx + 1 : 0;
  }

  hasPreviousLesson(): boolean {
    return this.getCurrentLessonIndex() > 0;
  }

  hasNextLesson(): boolean {
    const idx = this.getCurrentLessonIndex();
    const total = this.currentCurriculum && this.currentCurriculum.lessons ? this.currentCurriculum.lessons.length : 0;
    return idx >= 0 && idx < total - 1;
  }

  selectPreviousLesson(): void {
    const idx = this.getCurrentLessonIndex();
    if (idx > 0) {
      this.currentLesson = this.currentCurriculum.lessons[idx - 1];
    }
  }

  selectNextLesson(): void {
    const idx = this.getCurrentLessonIndex();
    const lessons = this.currentCurriculum && this.currentCurriculum.lessons;
    if (idx >= 0 && lessons && idx < lessons.length - 1) {
      this.currentLesson = lessons[idx + 1];
    }
  }

  private applyTheme() {
    const shell = document.getElementById('page-wrapper');
    if (shell) {
      shell.classList.toggle('theme-dark', this.isDarkTheme);
    }
    document.documentElement.classList.add('mkc-dashboard-shell');
    document.body.classList.add('mkc-dashboard-shell');
    document.documentElement.classList.toggle('mkc-theme-dark', this.isDarkTheme);
    document.body.classList.toggle('mkc-theme-dark', this.isDarkTheme);
  }
}
